import { Component, Inject, OnInit, inject, DestroyRef, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { Account } from 'app/core/models';
import { AccountService } from 'app/core/services';
import { FileResource } from 'app/shared/modules/folders/folders.types';
import { AccountFoldersService } from 'app/modules/folders/folders.service';

@Component({
  selector: 'generate-merge-document',
  templateUrl: './generate-merge-document.component.html',
  styleUrls: ['./generate-merge-document.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GenerateMergeDocumentComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);
  private fileResources: FileResource[];
  public projectForm: UntypedFormGroup;
  public filteredFileResources: FileResource[];
  public fileResourceFilterCtrl: UntypedFormControl = new UntypedFormControl();
  public account: Account;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<GenerateMergeDocumentComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly accountService: AccountService,
    private readonly accountFoldersService: AccountFoldersService,
  ) {
    this.accountService.currentAccount.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((accountData) => {
      this.account = accountData;
      this.accountFoldersService.accountId = accountData.id;
    });
  }

  ngOnInit(): void {
    this.projectForm = this.formBuilder.group({
      file_resource_id: ['', [Validators.required]],
    });

    this.accountFoldersService
      .getAllFiles(true)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((fileResources) => {
        this.fileResources = fileResources;
        this.fileResources = this.fileResources.filter(
          (option) =>
            option.name.toLowerCase().indexOf('.docx') > -1 ||
            option.name.toLowerCase().indexOf('.pdf') > -1 ||
            option.name.toLowerCase().indexOf('.pptx') > -1,
        );
        this.filteredFileResources = this.fileResources;
      });
  }

  ngAfterViewInit(): void {
    this.fileResourceFilterCtrl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.filterFileResources();
    });
  }

  private filterFileResources(): void {
    if (!this.fileResources) {
      return;
    }

    const search = this.fileResourceFilterCtrl.value?.toLowerCase();
    this.filteredFileResources = this.fileResources.filter((option) => option.name.toLowerCase().indexOf(search) > -1);
  }

  discard(): void {
    this.matDialogRef.close();
  }

  save(): void {
    this.projectForm.disable();

    const fileResourceId = this.projectForm.get('file_resource_id').value;
    const index = this.fileResources.findIndex((item) => item.id === fileResourceId);
    const fileResource = this.fileResources[index];

    if (!fileResource) {
      this.projectForm.enable();
      return;
    }

    let format = 'docx';
    if (fileResource.name.includes('pdf')) {
      format = 'pdf';
    } else if (fileResource.name.includes('pptx')) {
      format = 'pptx';
    }
    this.matDialogRef.close({
      file_resource_id: fileResourceId,
      format: format,
      action: 'generate',
      file_name: fileResource.name,
    });
  }

  sendToDocusign(): void {
    this.projectForm.disable();

    const fileResourceId = this.projectForm.get('file_resource_id').value;
    const index = this.fileResources.findIndex((item) => item.id === fileResourceId);
    const fileResource = this.fileResources[index];
    let format = 'docx';
    if (fileResource.name.includes('pdf')) {
      format = 'pdf';
    }
    this.matDialogRef.close({ file_resource_id: fileResourceId, format: format, action: 'docusign' });
  }
}
